import { scrollToAnchor } from "../core/global";
import Accordion, { AccordionOptions } from "./accordion";

interface AccordionWithVideoOptions extends AccordionOptions {
	el: string | NodeListOf<HTMLElement>
	trigger?: string
	firstOpen?: boolean
	activeClass?: string
	onOpen?: (el: HTMLElement, index: number) => void
	onClose?: (el: HTMLElement, index: number) => void
}


export class AccordionWithVideo extends Accordion {
	constructor(options: AccordionWithVideoOptions ) {
        super(options);
    }

    override handleToggle(): void {
		if(this.el.length === 0 || !this.trigger) return;

		if (this.firstOpen) {
			this.open(this.el[0], 0, true)
		}

		this.el.forEach((el, index) => {
			const trigger = el.querySelector<HTMLElement>(this.trigger as string)
			trigger?.addEventListener('click', () => {
				if(!this.showOne && el.classList.contains(this.activeClass)) {
					return this.close(el, index)
				} 

				if (this.showOne) {
					this.el.forEach((sibling, siblingIndex) => {
						if (sibling !== el) this.close(sibling, siblingIndex)
					})
				}
				this.open(el, index)
			})
		})
    }


	override open(el: HTMLElement, index: number, skipScrollToSection = false) {
		super.open(el, index)
		if(window.innerWidth < 992 && !skipScrollToSection) {
			setTimeout(() => {
				scrollToAnchor(el);
			}, 600)
		}
	}

	override close(el: HTMLElement, index: number) {
		super.close(el, index)

	}

	closeAll() {
		this.el.forEach((el, index) => {
			this.close(el, index)
		})
	}
}
